import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import SVG from "react-inlinesvg";
import Pagination from "rc-pagination";
import PaginationLocale from "rc-pagination/lib/locale/ja_JP";
import { useSearchParams } from "next/navigation";

export default function Component({ items, defaultCurrent, itemsPerPage, set_itemOffset, className = "" }) {
  const pageCount = Math.ceil(items.length / itemsPerPage);

  const pageChange = (page: number, pageSize: number) => {
    // set_currentPage(page)
    const newOffset = ((page-1) * itemsPerPage) % items.length;
    set_itemOffset(newOffset);
    // window.scroll(0,0)
  }
  // const handlePageClick = (event) => {
  //   const newOffset = (event.selected * itemsPerPage) % items.length;
  //   console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
  //   set_itemOffset(newOffset);
  // };

  return (
    <>
      <Pagination
        className={className+" en medi"}
        showLessItems
        // current={currentPage}
        defaultCurrent={defaultCurrent} // ページの初期値
        total={items.length}
        onChange={pageChange}
        pageSize={itemsPerPage} // １ページ当たりの件数
        hideOnSinglePage={true} // ページ送りが不要な場合は表示しない
        locale={PaginationLocale}
        prevIcon={<i className="icon-arrow"><SVG src="/assets/img/common/icon/icon-arrow-left.svg" /></i>}
        nextIcon={<i className="icon-arrow"><SVG src="/assets/img/common/icon/icon-arrow-right.svg" /></i>}
        jumpNextIcon={<span>・</span>}
        jumpPrevIcon={<span>・</span>}
      />

      {/*
      <ReactPaginate
        className={className}
        nextLabel="next >"
        onPageChange={handlePageClick}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        pageCount={pageCount}
        previousLabel="< previous"
        breakLabel="・"
        renderOnZeroPageCount={null}
      />
      */}
    </>
  );
}
